// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1_yUO","content":"LoadingAlert_content__2r7IP"};